const GiftIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="gift">
        <path
          id="Vector"
          d="M9 6.00037V15.7504M9 6.00037C8.72871 4.88242 8.26159 3.92662 7.65955 3.2577C7.05752 2.58877 6.34851 2.23772 5.625 2.25033C5.12772 2.25033 4.65081 2.44787 4.29917 2.7995C3.94754 3.15113 3.75 3.62805 3.75 4.12533C3.75 4.62261 3.94754 5.09952 4.29917 5.45115C4.65081 5.80278 5.12772 6.00033 5.625 6.00033M9 6.00037C9.27129 4.88242 9.73841 3.92662 10.3404 3.2577C10.9425 2.58877 11.6515 2.23772 12.375 2.25033C12.8723 2.25033 13.3492 2.44787 13.7008 2.7995C14.0525 3.15113 14.25 3.62805 14.25 4.12533C14.25 4.62261 14.0525 5.09952 13.7008 5.45115C13.3492 5.80278 12.8723 6.00033 12.375 6.00033M14.25 9.00037V14.2504C14.25 14.6482 14.092 15.0297 13.8107 15.311C13.5294 15.5923 13.1478 15.7504 12.75 15.7504H5.25C4.85218 15.7504 4.47064 15.5923 4.18934 15.311C3.90804 15.0297 3.75 14.6482 3.75 14.2504V9.00037M3 6.00037H15C15.4142 6.00037 15.75 6.33615 15.75 6.75037V8.25037C15.75 8.66458 15.4142 9.00037 15 9.00037H3C2.58579 9.00037 2.25 8.66458 2.25 8.25037V6.75037C2.25 6.33615 2.58579 6.00037 3 6.00037Z"
          stroke="#F04438"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default GiftIcon;
